__turbopack_context__.v({
  "group": "index-module__6kOaVq__group",
  "groupName": "index-module__6kOaVq__groupName",
  "itemList": "index-module__6kOaVq__itemList",
  "progression": "index-module__6kOaVq__progression",
});
